import { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './config/firebase';

import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import LiveMap from './pages/LiveMap';
import Trips from './pages/Trips';
import Drivers from './pages/Drivers';
import Users from './pages/Users';
import Blocks from './pages/Blocks';
import Analytics from './pages/Analytics';
import Messages from './pages/Messages';
import Settings from './pages/Settings';
import Admins from './pages/Admins';
import SupportChats from './pages/SupportChats';

function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const tokenResult = await currentUser.getIdTokenResult();
          if (tokenResult.claims.role === 'admin') {
            setUser(currentUser);
            setIsAdmin(true);
            if (location.pathname === '/login') {
              navigate('/');
            }
          } else {
            await auth.signOut();
            setUser(null);
            setIsAdmin(false);
          }
        } catch (error) {
          console.error("Error checking claims:", error);
          setUser(null);
          setIsAdmin(false);
        }
      } else {
        setUser(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate, location]);

  if (loading) {
    return (
      <div style={{display:'flex', height:'100vh', alignItems:'center', justifyContent:'center', background:'var(--bg-primary, #050811)'}}>
        <div className="spinner-lg" />
      </div>
    );
  }

  if (!user || !isAdmin) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <div className="app-shell">
      <Sidebar user={user} />
      <main className="app-main">
        {/* GLOBAL BACKGROUND LOGO */}
        {location.pathname !== '/map' && (
          <img 
            src="/log_o.png" 
            alt="" 
            style={{ 
              position: 'fixed', 
              top: '50%', 
              right: '-20%', 
              transform: 'translateY(-50%)', 
              height: '85vh', 
              opacity: 0.08, 
              pointerEvents: 'none',
              zIndex: 0,
              filter: 'drop-shadow(0 0 20px rgba(255, 215, 0, 0.2))'
            }} 
          />
        )}
        <div className="app-main-content" style={location.pathname === '/map' ? {} : { position: 'relative', zIndex: 1 }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/map" element={<LiveMap />} />
            <Route path="/trips" element={<Trips />} />
            <Route path="/drivers" element={<Drivers />} />
            <Route path="/users" element={<Users />} />
            <Route path="/blocks" element={<Blocks />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/support" element={<SupportChats />} />
            <Route path="/admins" element={<Admins />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default App;
